/** @jsx jsx */
import { useState, useEffect, useContext } from "react"
import { useStaticQuery, graphql } from "gatsby"
import { Box, jsx } from "theme-ui"
import Image from "gatsby-image"

import Navigation from "../Navigation"
import Announcement from "../Announcement"
import FixedNav from "../Navigation/FixedNav"

import { ShopifyContext } from "../../context/ShopifyContext"

import { Logo } from "../svg"

const styles = {
  header: {
    background: "#040e18",
    position: "relative",
    minHeight: [null, null, null, "880px"],
    height: "100vh",
    maxHeight: "-webkit-fill-available",
    overflow: "hidden",
    padding: ["12px 8px", "12px 8px", "12px 8px", "20px"],
    fontFamily: "body",
    ".logo": {
      position: "absolute",
      width: "100vw",
      left: "0px",
      bottom: "-11vw",
    },
  },
  image: {
    zIndex: 0,
    position: "absolute",
    width: "100%",
    height: "100%",
    left: "0px",
    top: "0px",
  },
  stamp: {
    zIndex: 1,
    position: "fixed",
    width: "200px",
    right: "20px",
    top: "80vh",
    transform: "translateY(-50%)",
  },
}

const Header = ({ isMobile, fixed }) => {
  const data = useStaticQuery(graphql`
    query HeaderQuery {
      sanityAnnouncementBar(_id: { eq: "announcementBar" }) {
        isActive
        expiresAt
        startsAt
        content
      }
      sanityHeader {
        links {
          title
          page {
            slug {
              current
            }
          }
        }
      }
      sanityAboveTheFold(_id: { eq: "aboveTheFold" }) {
        headline
        scrollButtonText
        hero {
          asset {
            localFile {
              childImageSharp {
                fluid(maxWidth: 1800) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
          }
        }
        heroMobile {
          asset {
            localFile {
              childImageSharp {
                fluid(maxWidth: 800) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
          }
        }
      }
    }
  `)
  const [announcementBarActive, setAnnouncementBarActive] = useState(false)

  const {
    checkout: { itemCount },
  } = useContext(ShopifyContext)

  const { sanityAnnouncementBar, sanityAboveTheFold, sanityHeader } = data
  const { isActive, startsAt, expiresAt, content } = sanityAnnouncementBar
  const { headline, scrollButtonText } = sanityAboveTheFold

  useEffect(() => {
    const started = startsAt && Date.now() > Date.parse(startsAt)
    const ended = expiresAt && Date.now() > Date.parse(expiresAt)

    if ((isActive && started && !ended) || (isActive && !started && !ended)) {
      setAnnouncementBarActive(true)
    }
  }, [setAnnouncementBarActive, sanityAnnouncementBar])

  return fixed ? (
    <Box id="header" as="header">
      <FixedNav cartCount={itemCount} defaultHidden={false} />
    </Box>
  ) : (
    <Box id="header" as="header" sx={styles.header}>
      {announcementBarActive && content && (
        <Announcement>{content}</Announcement>
      )}
      <Image
        loading="eager"
        style={styles.image}
        imgStyle={{
          backgroundColor: "#ADACA8",
          objectFit: "cover",
          objectPosition: "100% 50%",
        }}
        fluid={
          isMobile
            ? sanityAboveTheFold.heroMobile.asset.localFile.childImageSharp
                .fluid
            : sanityAboveTheFold.hero.asset.localFile.childImageSharp.fluid
        }
        alt="Marco's Sweets and Spices"
      />
      <Logo className="logo" />
      <h1 className="sr-only">{"Marco — Culinary Ice Cream"}</h1>
      <Navigation
        links={sanityHeader?.links || []}
        cartCount={itemCount}
        headline={headline}
        scrollButtonText={scrollButtonText}
      />
      <FixedNav links={sanityHeader?.links || []} cartCount={itemCount} />
    </Box>
  )
}
export default Header
